export enum EBoolean {
  False,
  True,
}
